import { ChevronDownIcon } from '@heroicons/react/outline';
import React, { useEffect, useRef, useState } from 'react';
import { useOutsideClick } from '../../firebase';

function SelectionMenu({
  options,
  selectedOption,
  handleSelect,
  placeholder,
  optionsVisible,
  setOptionsVisible,
}) {
  // const [optionsVisible, setOptionsVisible] = useState(false)

  const dropdownRef = useRef();
  useOutsideClick(dropdownRef, () => setOptionsVisible(false));

  const sortedOptions = [...options].sort((a, b) =>
    (a?.id || '').localeCompare(b?.id || '', undefined, { sensitivity: 'base' })
  );

  return (
    <div ref={dropdownRef} className="inline-block">
      <button
        className="border py-1 px-3 rounded-lg flex items-center min-w-[10rem] md:min-w-[16rem] max-w-[22rem]"
        onClick={() => setOptionsVisible((prev) => !prev)}
        title={selectedOption ? selectedOption.id : placeholder}
      >
        <span className="flex-1 text-left truncate">
          {selectedOption ? selectedOption.id : placeholder}
        </span>
        <ChevronDownIcon className="h-6 w-6 inline ml-2 shrink-0 grow-0" />
      </button>
      <div className={optionsVisible ? 'block' : 'hidden'}>
        <div className="absolute bg-white rounded-b-lg shadow-lg w-[100%] px-1 max-h-96 overflow-y-auto">
          {sortedOptions.map((option) => (
            <button
              key={option.id}
              onClick={() => handleSelect(option)}
              className={
                'doc-btn ' + (selectedOption?.id === option?.id ? 'bg-neutral-600 text-white' : '')
              }
              title={option?.id}
            >
              <span className="block w-full text-left truncate">{option?.id}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SelectionMenu;
